import { useInfiniteQuery } from "@tanstack/react-query";
import { details } from "@synthesis/shared-services/internal/monitoring/client";
import { detailsQueryKey } from "@synthesis/shared-services/internal/monitoring/hooks";

import { getMonitoringRailwayQuery, type MonitoringMetricItem } from "../monitoring-page.lib";

const PAGE_SIZE = 20;

export const useMonitoringApplications = (metric: MonitoringMetricItem, enabled: boolean) => {
  const query = { metric: metric.id, railway: getMonitoringRailwayQuery(metric.railwayId), size: PAGE_SIZE };

  return useInfiniteQuery({
    queryKey: [...detailsQueryKey({ query }), "infinite"],
    enabled,
    initialPageParam: 0,
    queryFn: async ({ pageParam, signal }) => {
      const { data } = await details({ query: { ...query, page: pageParam }, signal });
      return data;
    },
    getNextPageParam: (lastPage, _pages, pageParam) => {
      const nextPage = pageParam + 1;
      if (lastPage.totalPages != null) return nextPage < lastPage.totalPages ? nextPage : undefined;
      if (lastPage.totalElements != null) return nextPage * PAGE_SIZE < lastPage.totalElements ? nextPage : undefined;
      return lastPage.content?.length === PAGE_SIZE ? nextPage : undefined;
    },
  });
};
